fx.ns("repositories", class ServersRepository extends fx.ModelArray {

	constructor(data)
	{
		super(data);
	}

    get uploadServersUrls()
    {
        return this.uploadServers.map( (server) => server.url );
    }

    get uploadServers()
    {
        return this.filter( function(server) { return server.type == "upload"});
    }

    get resourceServers()
    {
        return this.filter( function(server) { return server.type == "resource"});
    }

    get aiServers()
    {
        return this.filter( function(server) { return server.type == "ai"});
    }

    get jobsServers()
    {
        return this.filter( function(server) { return server.type == "jobs"});
    }

    get iaEnabled()
    {
        return this.aiServers.length > 0;
    }
});